import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { contractsApi } from './api/contractsApi'
import { customersApi } from './api/customerApi'
import { documentsApi } from './api/documentsApi'
import { locationsApi } from './api/locationsApi'
import { notificationsApi } from './api/notificationsApi'
import { ordersApi } from './api/ordersApi'
import { reportsApi } from './api/reportsApi'
import { staticApi } from './api/staticApi'
import appData from './reducers/appDataReducer'
import contracts from './reducers/contractReducer'
import customers from './reducers/customerReducer'
import orders from './reducers/ordersReducer'

// TODO: enable serializable check and immutable check when ready

const rootReducer = combineReducers({
  appData,
  contracts,
  customers,
  orders,
  [customersApi.reducerPath]: customersApi.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
  [locationsApi.reducerPath]: locationsApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [documentsApi.reducerPath]: documentsApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [staticApi.reducerPath]: staticApi.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) =>
    getDefault({ serializableCheck: false, immutableCheck: false })
      .concat(customersApi.middleware)
      .concat(contractsApi.middleware)
      .concat(ordersApi.middleware)
      .concat(locationsApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(documentsApi.middleware)
      .concat(reportsApi.middleware)
      .concat(staticApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
